import { useEffect } from 'react';
import { useToast } from './useToast';
import { readAndDisplayFlashMessage } from '../utils/flashMessageUtils';

/**
 * Hook to handle flash messages passed from backend via cookies
 * Backend handlers set a 'react_flash' cookie with JSON: { type: 'success', message: '...' }
 * Runs automatically when component mounts (e.g., after page navigation/redirects)
 */
export function useFlashMessages() {
  const { showToast } = useToast();

  useEffect(() => {
    // Use longer duration for page-load flash messages (5 seconds)
    readAndDisplayFlashMessage(showToast, 5000);
  }, [showToast]);
}
